import styled from 'styled-components';
import {Button, CustomIcon} from '@guestapp/old-ui-kit';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {FormFieldWrapper} from 'styled/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  width: 100%;

  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 48px;
  }
`;

export const CustomBackButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  margin: 24px 0;

  & .button__left-icon {
    padding-right: 10px;
  }
`;

export const Fields = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  display: flex;

  @media (min-width: ${DEVICE.laptopL}) {
    flex-direction: row;
    width: 614px;
    justify-content: space-between;
  }
`;

export const FormWrapper = styled.div`
  margin: 0 auto;
  @media (min-width: ${DEVICE.laptop}) {
    display: flex;
    align-items: flex-start;
    width: 100%;
    max-width: 1280px;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;

  @media (min-width: ${DEVICE.laptop}) {
    justify-content: start;
  }
`;

export const StyledBackIcon = styled(CustomIcon)`
  display: flex;
  justify-content: center;
  align-items: center;

  path {
    fill: ${({theme}) =>
      theme.hasTemplate
        ? theme.colors.branding.icons
        : theme.colors.navigationMenu.selectedItemText};
  }
`;

export const StyledButton = styled(Button)`
  min-width: 295px;
  @media (min-width: ${DEVICE.laptop}) {
    min-width: 205px;
  }
`;

export const StyledFormFieldWrapper = styled(FormFieldWrapper)`
  & .fieldset__label {
    text-transform: none;
  }

  width: 100%;
  @media (min-width: ${DEVICE.laptop}) {
    width: 295px;
  }
`;
